/* The counter to the drop. One script for every counter in the shop: the one
   on the home page and the one on the holding page read the same date from
   the theme settings and count the same way. Each counter carries what it
   needs on its own element, so the script knows nothing about the page. */
(function(){
'use strict';

if(window.cvzDropClock) return;

/* the date is typed by hand, so read it the way people actually write it:
   28.11.2026 and 2026-11-28 both mean the same evening */
function readDate(s){
  s = String(s == null ? '' : s).trim();
  if(!s) return null;
  var m = s.match(/^(\d{4})\D(\d{1,2})\D(\d{1,2})$/);
  if(m) return [+m[1], +m[2], +m[3]];
  m = s.match(/^(\d{1,2})\D(\d{1,2})\D(\d{4})$/);
  if(m) return [+m[3], +m[2], +m[1]];
  return null;
}

function readTime(s){
  s = String(s == null ? '' : s).trim().toLowerCase();
  if(!s) return [0, 0];
  var pm = /p\.?m/.test(s), am = /a\.?m/.test(s);
  s = s.replace(/[ap]\.?m\.?/g, '').trim();
  var m = s.match(/^(\d{1,2})(?:\D(\d{1,2}))?$/);
  if(!m) return null;
  var h = +m[1], mi = m[2] ? +m[2] : 0;
  if(pm && h < 12) h += 12;
  if(am && h === 12) h = 0;
  if(h > 23 || mi > 59) return null;
  return [h, mi];
}

var pad = function(n){ return n < 10 ? '0' + n : '' + n; };

function start(root){
  if(root._cvzTimer) clearInterval(root._cvzTimer);

  var $ = function(s){ return root.querySelector(s); };
  var clock = $('[data-cvz-clock]');
  var bar   = $('[data-cvz-bar] i');
  var when  = $('[data-cvz-when]');
  var live  = $('[data-cvz-live]');
  var right = $('[data-cvz-right]');
  var hint  = $('[data-cvz-hint]');

  var d = root.dataset;
  var zone = d.zone || 'Europe/Sofia';
  var mode = d.mode || 'live';
  var days = parseInt(d.window, 10) || 14;
  var span = days * 864e5;
  var editing = !!(window.Shopify && window.Shopify.designMode);

  /* how far the named zone sits from UTC at that exact moment, which is the
     only way to get an evening in November right from a page built in September */
  function offsetAt(ts){
    try{
      var f = new Intl.DateTimeFormat('en-US', {timeZone: zone, hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'});
      var parts = f.formatToParts(new Date(ts)), p = {}, i;
      for(i = 0; i < parts.length; i++) p[parts[i].type] = parts[i].value;
      var hh = p.hour === '24' ? 0 : +p.hour;
      return Date.UTC(+p.year, p.month - 1, +p.day, hh, +p.minute, +p.second) - ts;
    }catch(e){ return null; }
  }

  function toInstant(y, mo, dd, h, mi){
    var wall = Date.UTC(y, mo - 1, dd, h, mi, 0), ts = wall, off, i;
    for(i = 0; i < 3; i++){
      off = offsetAt(ts);
      if(off === null) return wall;
      ts = wall - off;
    }
    return ts;
  }

  function stand(msg){
    root.classList.add('no-date');
    if(clock) clock.hidden = true;
    if(bar && bar.parentNode) bar.parentNode.hidden = true;
    if(when) when.hidden = true;
    if(right) right.hidden = true;
    if(editing && hint && msg){ hint.textContent = msg; hint.hidden = false; }
  }

  var parts = readDate(d.date);
  var clk = readTime(d.time);

  if(!parts){
    stand(String(d.date || '').trim()
      ? 'The drop date is not readable: "' + d.date + '". Write it as 2026-11-28 or 28.11.2026, under Theme settings, The drop. This note is only visible to you here in the editor.'
      : 'No drop date yet, so the counter stays away. Add one under Theme settings, The drop. This note is only visible to you here in the editor.');
    return;
  }
  if(parts[1] < 1 || parts[1] > 12 || parts[2] < 1 || parts[2] > 31){
    stand('That date has a month or a day out of range: "' + d.date + '". This note is only visible to you here in the editor.');
    return;
  }
  if(!clk){
    stand('The drop time is not readable: "' + d.time + '". Write it as 20:00. This note is only visible to you here in the editor.');
    return;
  }

  var current = toInstant(parts[0], parts[1], parts[2], clk[0], clk[1]);
  if(isNaN(current)){ stand('The drop date could not be worked out.'); return; }

  /* 11/28 and 28/11 are the same day to a machine and two different days to a
     reader, so the line is built by hand rather than left to a locale */
  function label(ts){
    try{
      var f = new Intl.DateTimeFormat(document.documentElement.lang || 'en',
        {timeZone: zone, weekday: 'short', day: '2-digit', month: '2-digit',
         hour: '2-digit', minute: '2-digit', hour12: false});
      var ps = f.formatToParts(new Date(ts)), p = {}, i;
      for(i = 0; i < ps.length; i++) p[ps[i].type] = ps[i].value;
      return p.weekday + ' ' + p.day + '.' + p.month + ' · ' + p.hour + ':' + p.minute;
    }catch(e){
      var dt = new Date(ts);
      return pad(dt.getDate()) + '.' + pad(dt.getMonth() + 1);
    }
  }

  /* stepping by a fixed number of milliseconds drifts an hour every autumn,
     so the next one is worked out on the calendar and resolved again */
  function advance(now){
    var day = parts[2], guard = 0, t = current;
    while(t <= now && guard++ < 4000){
      day += days;
      t = toInstant(parts[0], parts[1], day, clk[0], clk[1]);
    }
    parts[2] = day;
    return t;
  }

  function paint(){
    var now = Date.now();
    if(mode === 'roll' && current <= now) current = advance(now);
    var t = current;

    if(t <= now){
      if(root._cvzTimer){ clearInterval(root._cvzTimer); root._cvzTimer = null; }
      if(mode === 'hide'){ root.hidden = true; return; }
      root.classList.add('is-open');
      if(live) live.hidden = false;
      if(right && d.openRight) right.textContent = d.openRight;
      return;
    }

    var left = t - now;
    clock.querySelector('[data-unit="d"]').textContent = pad(Math.floor(left / 864e5));
    clock.querySelector('[data-unit="h"]').textContent = pad(Math.floor(left / 36e5) % 24);
    clock.querySelector('[data-unit="m"]').textContent = pad(Math.floor(left / 6e4) % 60);
    clock.querySelector('[data-unit="s"]').textContent = pad(Math.floor(left / 1e3) % 60);
    if(bar) bar.style.width = Math.max(2, Math.min(100, Math.round((1 - left / span) * 100))) + '%';
    if(when) when.textContent = label(t);
  }

  paint();
  if(!root.classList.contains('is-open') && !root.hidden) root._cvzTimer = setInterval(paint, 1000);
}

function startAll(scope){
  var list = (scope || document).querySelectorAll('[data-drop]');
  for(var i = 0; i < list.length; i++) start(list[i]);
}

window.cvzDropClock = startAll;

if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ startAll(); });
else startAll();

/* the editor rebuilds a section on every keystroke in the sidebar: the new one
   is started, and the old one is stopped so two counters never fight over the
   same digits */
document.addEventListener('shopify:section:load', function(e){ startAll(e.target); });
document.addEventListener('shopify:section:unload', function(e){
  var list = e.target.querySelectorAll('[data-drop]');
  for(var i = 0; i < list.length; i++) if(list[i]._cvzTimer) clearInterval(list[i]._cvzTimer);
});
})();
